import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { AIButtonContainedDark } from '../../../AIButton'
import Text from '../../../Text'
import { GretaAIChatNewProject } from '../../GretaAIChatNewProject'

import * as styles from './GretaAIChatProjectsPageHeader.module.css'

import PlusIcon from '../../../../icons/plus.svg'

function GretaAIChatProjectsPageHeader({ count, isCountShown = false }) {
  const { t } = useTranslation()

  return (
    <div className={styles.header}>
      <div className={styles.heading}>
        <Text Element='h1' className={styles.title}>
          {t('Greta.ProjectsSectionKey')}
        </Text>
        {isCountShown ? (
          <Text isSecondary Element='p' className={styles.count}>
            {t('Greta.ProjectsCountKey', { count })}
          </Text>
        ) : null}
      </div>
      <GretaAIChatNewProject
        Trigger={AIButtonContainedDark}
        placement={FLOATING_ELEMENT_PLACEMENT.bottomEnd}
        triggerProps={{
          beforeIconProps: { Icon: PlusIcon },
          text: t('Greta.NewProjectKey'),
        }}
      />
    </div>
  )
}

export default GretaAIChatProjectsPageHeader
